let deferredPrompt: any = null;
let installHandlers: ((canInstall: boolean) => void)[] = [];

window.addEventListener('beforeinstallprompt', e => {
  e.preventDefault();
  deferredPrompt = e;
  console.log('[PWA] Install prompt ready');
  installHandlers.forEach(handler => handler(true));
});

window.addEventListener('appinstalled', () => {
  console.log('[PWA] App installed!');
  deferredPrompt = null;
  installHandlers.forEach(handler => handler(false));
  localStorage.setItem('papacito_installed', Date.now().toString());
});

export function onInstallAvailable(handler: (canInstall: boolean) => void) {
  installHandlers.push(handler);
  if (deferredPrompt) {
    handler(true);
  }
  return () => {
    installHandlers = installHandlers.filter(h => h !== handler);
  };
}

export async function triggerInstall(): Promise<'accepted' | 'dismissed' | 'unavailable'> {
  if (!deferredPrompt) {
    return 'unavailable';
  }
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  console.log('[PWA] Install outcome:', outcome);
  deferredPrompt = null;
  installHandlers.forEach(h => h(false));
  return outcome as 'accepted' | 'dismissed';
}

export function canInstallNow(): boolean {
  return deferredPrompt !== null;
}

export function isInstalled(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true ||
    document.referrer.includes('android-app://')
  );
}

export function isAndroid(): boolean {
  return /Android/i.test(navigator.userAgent);
}

export function isIOS(): boolean {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isChrome(): boolean {
  return /Chrome/i.test(navigator.userAgent) && !/Chromium/i.test(navigator.userAgent);
}

export function getIOSVersion(): number {
  const match = navigator.userAgent.match(/OS (\d+)_/);
  return match ? parseInt(match[1]) : 0;
}

export function isIOS18OrLater(): boolean {
  return isIOS() && getIOSVersion() >= 18;
}
